import ActionHandlerSagas from "./actionHandlerSagas";
import BetsSagas from "./betsSagas";
import SearchSagas from "./searchSagas";
import UserContextSagas from "./userContextSagas";
import { all } from "redux-saga/effects";

const sagas = [
  ...SearchSagas,
  ...UserContextSagas,
  ...BetsSagas,
  ...ActionHandlerSagas
];

export default function* rootSaga() {
  yield all(sagas);
}
